module.exports = __webpack_public_path__ + "media/images/van-7cba60e2ee2c0c0821d9e43c256e2815.svg";